import { useState, useEffect } from "react";

export const useCartCountdown = (cart, onCartTimeout) => {
  const [countdown, setCountdown] = useState(cart.secondsLeft);

  useEffect(() => {
    const isInitialLoad =
      !cart.isCartLoading && cart.isInitialCardsLoaded && !cart.timeIsUp;
    const hasCards = !!cart.cards?.length;

    if (isInitialLoad && hasCards) {
      setCountdown(cart.secondsLeft);

      const timer = setInterval(() => {
        setCountdown((current) => {
          if (current === 0) {
            clearInterval(timer);
            onCartTimeout();
            return 0;
          }
          return current - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart]);

  return countdown;
};
